import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentSigningComponent } from './document-signing.component';
import { ViewDocumentComponent } from './view-document/view-document.component';

const routes: Routes = [
  {
    path: '',
    component: DocumentSigningComponent,
  },
  {
    path: 'view',
    component: ViewDocumentComponent,
  },
];
export const documentSignRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
